(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["osn-collection-tabs"] && !Shopify.designMode) return;
  try {
    
class OsnCollectionTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[data-osn-ctabs-tab]'));
    this.panels = Array.from(this.querySelectorAll('.osn-ctabs__panel'));
    this.viewAll = this.querySelector('[data-osn-ctabs-viewall]');
    this.onClick = this.onClick.bind(this);
    this.onKeydown = this.onKeydown.bind(this);
    this.tabs.forEach((tab) => {
      tab.addEventListener('click', this.onClick);
      tab.addEventListener('keydown', this.onKeydown);
    });
  }

  onClick(event) {
    this.activate(event.currentTarget);
  }

  onKeydown(event) {
    const index = this.tabs.indexOf(event.currentTarget);
    let next = null;
    if (event.key === 'ArrowRight') next = this.tabs[(index + 1) % this.tabs.length];
    if (event.key === 'ArrowLeft') next = this.tabs[(index - 1 + this.tabs.length) % this.tabs.length];
    if (next) {
      event.preventDefault();
      next.focus();
      this.activate(next);
    }
  }

  activate(tab) {
    const targetId = tab.getAttribute('aria-controls');
    this.tabs.forEach((t) => {
      const active = t === tab;
      t.classList.toggle('is-active', active);
      t.setAttribute('aria-selected', active ? 'true' : 'false');
      t.tabIndex = active ? 0 : -1;
    });
    this.panels.forEach((panel) => {
      const active = panel.id === targetId;
      panel.classList.toggle('is-active', active);
      if (active) panel.removeAttribute('hidden');
      else panel.setAttribute('hidden', '');
    });
    if (this.viewAll) {
      const collectionUrl = tab.dataset.collectionUrl;
      this.viewAll.href = collectionUrl || this.viewAll.dataset.fallbackUrl || '#';
    }
  }
}
customElements.define('osn-collection-tabs', OsnCollectionTabs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["osn-hero"] && !Shopify.designMode) return;
  try {
    
class OsnHeroSlider extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.osn-hero__track');
    this.slides = Array.from(this.querySelectorAll('.osn-hero__slide'));
    this.dots = Array.from(this.querySelectorAll('[data-osn-hero-dot]'));
    this.prevBtn = this.querySelector('[data-osn-hero-prev]');
    this.nextBtn = this.querySelector('[data-osn-hero-next]');
    this.current = 0;

    if (this.slides.length < 2) return;

    this.onPrev = () => this.goTo(this.current - 1);
    this.onNext = () => this.goTo(this.current + 1);
    this.prevBtn && this.prevBtn.addEventListener('click', this.onPrev);
    this.nextBtn && this.nextBtn.addEventListener('click', this.onNext);
    this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.goTo(i)));

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const idx = this.slides.indexOf(entry.target);
            if (idx > -1) this.setActive(idx);
          }
        });
      },
      { root: this.track, threshold: 0.6 }
    );
    this.slides.forEach((slide) => this.observer.observe(slide));

    if (this.dataset.autoplay === 'true') {
      const delay = parseInt(this.dataset.autoplayDelay, 10) || 5000;
      this.timer = setInterval(() => {
        this.goTo((this.current + 1) % this.slides.length);
      }, delay);
      this.addEventListener('mouseenter', () => clearInterval(this.timer));
      this.addEventListener('mouseleave', () => {
        this.timer = setInterval(() => this.goTo((this.current + 1) % this.slides.length), delay);
      });
    }
  }

  goTo(index) {
    const clamped = (index + this.slides.length) % this.slides.length;
    this.slides[clamped].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
  }

  setActive(index) {
    this.current = index;
    this.slides.forEach((slide, i) => slide.setAttribute('aria-hidden', i === index ? 'false' : 'true'));
    this.dots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === index);
      dot.setAttribute('aria-selected', i === index ? 'true' : 'false');
    });
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
    if (this.timer) clearInterval(this.timer);
  }
}
customElements.define('osn-hero-slider', OsnHeroSlider);

document.querySelectorAll('[data-osn-hero]').forEach((el) => {
  if (!el.closest('osn-hero-slider')) {
    const wrapper = document.createElement('osn-hero-slider');
    el.parentNode.insertBefore(wrapper, el);
    wrapper.appendChild(el);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["osn-quiz-modal"] && !Shopify.designMode) return;
  try {
    
class OsnQuizModal extends HTMLElement {
  connectedCallback() {
    this.body = this.querySelector('[data-osn-quiz-body]');
    this.progress = this.querySelector('[data-osn-quiz-progress]');
    this.progressFill = this.querySelector('[data-osn-quiz-progress-fill]');
    this.progressLabel = this.querySelector('[data-osn-quiz-progress-label]');
    this.backBtn = this.querySelector('[data-osn-quiz-back]');
    this.stepsEl = this.querySelector('[data-osn-quiz-steps]');
    this.stepEls = this.querySelectorAll('.osn-quiz__step');
    this.iconStore = this.querySelector('[data-osn-quiz-icon-store]');
    this.resultsEl = this.querySelector('[data-osn-quiz-results]');
    this.resultTitle = this.querySelector('[data-osn-quiz-result-title]');
    this.resultSubtitle = this.querySelector('[data-osn-quiz-result-subtitle]');
    this.resultHighlights = this.querySelector('[data-osn-quiz-result-highlights]');
    this.maxProducts = parseInt(this.dataset.maxProducts, 10) || 6;

    this.data = null;
    this.answers = {};
    this.step = 0; // 0 = intro, 1-5 = questions

    this.querySelectorAll('[data-osn-quiz-close]').forEach((el) => el.addEventListener('click', () => this.close()));
    this.backBtn.addEventListener('click', () => this.goBack());
    this.querySelector('[data-osn-quiz-retake]').addEventListener('click', () => this.retake());

    document.addEventListener('click', (event) => {
      if (event.target.closest('[data-osn-quiz-open]')) {
        event.preventDefault();
        this.open();
      }
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.classList.contains('is-open')) this.close();
    });
  }

  async open() {
    this.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    if (!this.data) {
      try {
        const response = await fetch(this.dataset.jsonUrl);
        this.data = await response.json();
      } catch (error) {
        this.body.innerHTML = '<p style="text-align:center;font-size:13px;color:#999;">Sorry, the quiz couldn\'t load right now.</p>';
        return;
      }
    }
    this.answers = {};
    this.resultsEl.hidden = true;
    this.goToStep(0);
  }

  close() {
    this.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  retake() {
    this.resultsEl.hidden = true;
    this.body.hidden = false;
    this.answers = {};
    this.goToStep(0);
  }

  goBack() {
    if (this.step > 0) this.goToStep(this.step - 1);
  }

  goToStep(step) {
    this.step = step;
    const totalQuestions = this.data.questions.length;
    this.backBtn.hidden = step === 0;

    if (step === 0) {
      this.progress.hidden = true;
      this.updateSteps(0);
      this.renderIntro();
      return;
    }

    this.progress.hidden = false;
    this.progressFill.style.width = Math.round((step / totalQuestions) * 100) + '%';
    this.progressLabel.textContent = step + ' OF ' + totalQuestions;
    this.updateSteps(step);
    this.renderQuestion(step - 1);
  }

  updateSteps(activeStep) {
    this.stepEls.forEach((el) => {
      const index = parseInt(el.dataset.stepIndex, 10);
      el.classList.toggle('is-active', index === activeStep);
      el.classList.toggle('is-done', index < activeStep);
    });
  }

  renderIntro() {
    const intro = this.data.intro;
    const bullets = intro.bullets.map((bullet) => '<li></li>').join('');
    this.body.innerHTML =
      '<div class="osn-quiz-intro">' +
      '<p class="osn-quiz-intro__eyebrow"></p>' +
      '<h2 class="osn-quiz-intro__title"></h2>' +
      '<p class="osn-quiz-intro__subtitle"></p>' +
      '<ul class="osn-quiz-intro__bullets">' + bullets + '</ul>' +
      '<button type="button" class="osn-quiz-intro__start"></button>' +
      '</div>';

    this.body.querySelector('.osn-quiz-intro__eyebrow').textContent = intro.eyebrow;
    this.body.querySelector('.osn-quiz-intro__title').textContent = intro.title;
    this.body.querySelector('.osn-quiz-intro__subtitle').textContent = intro.subtitle;
    this.body.querySelectorAll('.osn-quiz-intro__bullets li').forEach((li, i) => { li.textContent = intro.bullets[i]; });
    const startBtn = this.body.querySelector('.osn-quiz-intro__start');
    startBtn.textContent = intro.start_label;
    startBtn.addEventListener('click', () => this.goToStep(1));
  }

  renderQuestion(index) {
    const question = this.data.questions[index];
    const hasIcons = question.options.some((option) => option.icon);
    const optionsHtml = question.options.map((option, i) => (
      '<button type="button" class="osn-quiz-option' + (option.icon ? ' osn-quiz-option--icon' : '') + '" data-option-index="' + i + '">' +
      (option.icon ? '<span class="osn-quiz-option__icon" data-option-icon></span>' : '') +
      '<span class="osn-quiz-option__text"><span class="osn-quiz-option__label"></span>' +
      (option.sublabel ? '<span class="osn-quiz-option__sublabel"></span>' : '') +
      '</span></button>'
    )).join('');

    this.body.innerHTML =
      '<div class="osn-quiz-question">' +
      '<h2 class="osn-quiz-question__title"></h2>' +
      '<div class="osn-quiz-question__options' + (hasIcons ? ' osn-quiz-question__options--icons' : '') + '">' + optionsHtml + '</div>' +
      '</div>';

    this.body.querySelector('.osn-quiz-question__title').textContent = question.title;
    const buttons = this.body.querySelectorAll('.osn-quiz-option');
    buttons.forEach((button, i) => {
      const option = question.options[i];
      button.querySelector('.osn-quiz-option__label').textContent = option.label;
      const sub = button.querySelector('.osn-quiz-option__sublabel');
      if (sub) sub.textContent = option.sublabel;
      const iconSlot = button.querySelector('[data-option-icon]');
      if (iconSlot && this.iconStore) {
        const source = this.iconStore.querySelector('[data-icon="' + option.icon + '"]');
        if (source) iconSlot.innerHTML = source.innerHTML;
      }
      button.addEventListener('click', () => this.selectOption(question.id, option.value));
    });
  }

  selectOption(questionId, value) {
    this.answers[questionId] = value;
    if (this.step >= this.data.questions.length) {
      this.showResult();
    } else {
      this.goToStep(this.step + 1);
    }
  }

  showResult() {
    const goal = this.answers.goal;
    const result = this.data.results[goal];
    if (!result) return;

    this.progress.hidden = true;
    this.backBtn.hidden = true;
    this.body.hidden = true;
    this.resultsEl.hidden = false;
    this.updateSteps(6);

    this.resultTitle.textContent = result.title;
    this.resultSubtitle.textContent = result.subtitle;
    this.resultHighlights.innerHTML = '';
    result.highlights.forEach((highlight) => {
      const li = document.createElement('li');
      li.textContent = highlight;
      this.resultHighlights.appendChild(li);
    });

    const count = this.data.recommendation_type_product_count[this.answers.recommendation_type] || this.maxProducts;
    this.resultsEl.querySelectorAll('[data-result-panel]').forEach((panel) => {
      const isMatch = panel.dataset.resultPanel === goal;
      panel.hidden = !isMatch;
      if (isMatch) {
        panel.querySelectorAll('[data-product-index]').forEach((productEl) => {
          productEl.hidden = parseInt(productEl.dataset.productIndex, 10) >= count;
        });
      }
    });

    this.resultsEl.scrollIntoView({ block: 'start' });
  }

  disconnectedCallback() {
    document.body.style.overflow = '';
  }
}
customElements.define('osn-quiz-modal', OsnQuizModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["osn-video-banner"] && !Shopify.designMode) return;
  try {
    
class OsnVideoBanner extends HTMLElement {
  connectedCallback() {
    this.video = this.querySelector('[data-osn-video]');
    if (!this.video) return;

    this.video.muted = true;
    this.video.addEventListener('playing', () => this.classList.add('is-playing'), { once: true });
    this.muteButton = this.querySelector('[data-osn-video-mute]');
    if (this.muteButton) {
      this.onMuteClick = this.onMuteClick.bind(this);
      this.muteButton.addEventListener('click', this.onMuteClick);
    }

    this.onIntersect = this.onIntersect.bind(this);
    this.observer = new IntersectionObserver(this.onIntersect, { threshold: 0.5 });
    this.observer.observe(this.video);
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
  }

  onIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        this.video.play().catch(() => {});
      } else {
        this.video.pause();
      }
    });
  }

  onMuteClick() {
    this.video.muted = !this.video.muted;
    this.muteButton.classList.toggle('is-unmuted', !this.video.muted);
    this.muteButton.setAttribute(
      'aria-label',
      this.video.muted ? 'Unmute video' : 'Mute video'
    );
  }
}
customElements.define('osn-video-banner', OsnVideoBanner);

  } catch(e) { console.error(e); }
})();
})();
